module.exports = __webpack_public_path__ + "static/concat-bg.a2e5b367.png";